// extracted by mini-css-extract-plugin
export default {"root":"RangeSliderRating_root__+6+8Z"};